import React from "react";
import Dispatcher from "../../dispatcher";

class BookPlaceholder extends React.Component {
  constructor(props) {
    super(props);

    this._updateLocation = this._updateLocation.bind(this);

    this.iframePlaceholderRef = React.createRef();
  }

  componentDidMount() {
    this.iframePlaceholderRef.current.contentWindow.addEventListener(
      "resize",
      this._updateLocation
    );
    Dispatcher.emit(Dispatcher.BOOK_PLACEHOLDER_RESIZE);
  }

  componentWillUnmount() {
    this.iframePlaceholderRef.current.contentWindow.removeEventListener(
      "resize",
      this._updateLocation
    );
    Dispatcher.emit(Dispatcher.BOOK_PLACEHOLDER_RESIZE);
  }

  _updateLocation() {
    Dispatcher.emit(Dispatcher.BOOK_PLACEHOLDER_RESIZE);
  }

  render() {
    return (
      <div id="book-placeholder-container">
        <iframe
          aria-hidden="true"
          ref={this.iframePlaceholderRef}
          id="book-container-iframe-placeholder"
        />
      </div>
    );
  }
}

BookPlaceholder.propTypes = {};

BookPlaceholder.defaultProps = {};

module.exports = BookPlaceholder;
